<template>
  <el-dropdown :trigger="trigger" :placement="placement" @command="handleCommand">
    <el-button size="mini" type="primary">
      {{ buttonText }} <i class="el-icon-arrow-down el-icon--right" />
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="(item, index) in dropdownItem"
        :key="index"
        :command="typeof item == 'string' ? index : item.value"
        :class="{
          'dropdown-active': activeCommand === (typeof item == 'string' ? index : item.value),
        }"
        :disabled="typeof item == 'string' ? false : item.disabled || false"
      >
        {{ typeof item == 'string' ? item : item.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
co
<script>
  export default {
    props: {
      /**
       * 下拉菜单数组
       * 数组内容：
       * 文案、
       * 或者对象 {value: '', label: '', disabled: }
       */
      dropdownItem: {
        type: Array,
        default: () => [],
      },
      buttonText: {
        // 按钮文案
        type: String,
        default: '',
      },
      trigger: {
        // 触发方式
        type: String,
        default: 'hover',
      },
      placement: {
        type: String,
        default: 'bottom-end',
      },
    },
    data() {
      return {
        // 当前选中command
        activeCommand: '',
      };
    },
    methods: {
      handleCommand(command) {
        this.activeCommand = command;
        this.$emit('change', command);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .el-dropdown {
    vertical-align: top;
    .el-button {
      padding: 8px 15px;
    }
  }
</style>
